import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../utils/cn'

const textVariants = cva('font-creato text-primary leading-5', {
  variants: {
    size: {
      small: 'text-[14px]',
      base: 'text-[16px]',
    },
    weight: {
      light: 'font-light',
      medium: 'font-medium',
    },
  },
  defaultVariants: {
    size: 'base',
    weight: 'light',
  },
})

export interface TextProps extends React.HTMLAttributes<HTMLElement>, VariantProps<typeof textVariants> {
  asChild?: boolean
  as?: 'p' | 'span' | 'div' | 'strong' | 'em' | 'label' // Поддерживаемые теги
}

export  const Text = React.forwardRef<HTMLElement, TextProps>(({ className, size, weight, asChild = false, as = 'p', ...props }, ref) => {
  const Comp: React.ElementType = asChild ? Slot : as

  return (
    <Comp
      className={cn(textVariants({ size, weight }), className)}
      ref={ref as React.Ref<HTMLElement>}
      {...props}
    />
  )
})

Text.displayName = 'Text'

const headingVariants = cva('font-creato text-primary line-normal', {
  variants: {
    size: {
      small: 'text-[18px]',
      base: 'text-[20px]',
      large: 'text-[28px]',
      xl: 'text-[34px]',
    },
    weight: {
      light: 'font-light',
      medium: 'font-medium',
    },
  },
  defaultVariants: {
    size: 'base',
    weight: 'medium',
  },
})

export interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement>, VariantProps<typeof headingVariants> {
  asChild?: boolean
  as?: 'h1' | 'h2' | 'h3' | 'h4' // Поддерживаемые теги
}

export const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(({ className, size = 'base', weight, asChild = false, as = 'h3', ...props }, ref) => {
  const Comp: React.ElementType = asChild ? Slot : as

  return (
    <Comp
      className={cn(headingVariants({ size, weight }), className)}
      ref={ref as React.Ref<HTMLHeadingElement>}
      {...props}
    />
  )
})

Heading.displayName = 'Heading'
// const typographyVariants = cva('font-creato', {
//   variants: {
//     variant: {
//       heading: ' ',
//       text: 'leading-5',
//     },
//     size: {
//       small: 'text-[14px]',
//       base: 'text-[16px]',
//       large: 'text-[28px]',
//       xlarge: 'text-[34px]',
//     },
//     weight: {
//       light: 'font-light',
//       medium: 'font-medium',
//     },
//   },
//   compoundVariants: [
//     {
//       variant: 'heading',
//       size: 'base',
//       className: 'text-[20px]',
//     },
//     {
//       variant: 'heading',
//       size: 'small',
//       className: 'text-[18px]',
//     },
//   ],
//   defaultVariants: {
//     variant: 'heading',
//   },
// })

// export interface TypographyProps extends React.HTMLAttributes<HTMLElement>, VariantProps<typeof typographyVariants> {
//   asChild?: boolean
// }

// const Typography = React.forwardRef<HTMLElement, TypographyProps>(({ className, size, weight, variant = 'heading', asChild = false, ...props }, ref) => {
//   const Comp = asChild ? Slot : variant || 'p'
//   return (
//     <Comp
//       className={cn(typographyVariants({ variant, className, size, weight }))}
//       ref={ref as React.Ref<HTMLElement>}
//       {...props}
//     />
//   )
// })
// Typography.displayName = 'Typography'
